import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { CrisprService } from './crispr.service';
import { CatPartBaseDto } from '../api/catPartBaseDto';
import { ShopCartItemDto, ShopCartDto, CartState } from '../api/cartDto';

@Injectable({
	providedIn: 'root'
})
export class CrisprCartService {
	private cartSource: BehaviorSubject<Map<CatPartBaseDto, number>>;
	cart$: Observable<Map<CatPartBaseDto, number>>;
	private cartState: BehaviorSubject<CartState>;
	cartState$: Observable<CartState>;

	constructor(private crisprService: CrisprService) {
		this.cartSource = new BehaviorSubject<Map<CatPartBaseDto, number>>(new Map());
		this.cart$ = this.cartSource.asObservable();
		this.cartState = new BehaviorSubject<CartState>(null);
		this.cartState$ = this.cartState.asObservable();
	}

	initCart(response: ShopCartDto) {
		const cartCopy = new Map<CatPartBaseDto, number>();
		response.items.forEach((cartItem: ShopCartItemDto) => {
			cartCopy.set(cartItem.shopItem, cartItem.qty);
		});
		this.cartSource.next(cartCopy);
		this.cartState.next(response.state);
	}

	addItemToCart(item: CatPartBaseDto, quantity = 1) {
		this.crisprService.addToCart(item.id).subscribe(() => {
			const cartCopy = new Map(this.cartSource.getValue());
			const alreadyInCart = cartCopy.get(item) || 0;
			cartCopy.set(item, alreadyInCart + quantity);
			this.cartSource.next(cartCopy);
		});
	}

	deleteItemFromCart(item: CatPartBaseDto) {
		this.crisprService.removeFromCart(item.id).subscribe(() => {
			const cartCopy = new Map(this.cartSource.getValue());
			const alreadyInCart = cartCopy.get(item) || 0;
			if (alreadyInCart > 1) {
				cartCopy.set(item, alreadyInCart - 1);
			} else {
				cartCopy.delete(item);
			}
			this.cartSource.next(cartCopy);
		});
	}

	emptyCart() {
		this.cartSource.next(new Map());
		return 'deleted';
	}
}